// extracted by mini-css-extract-plugin
module.exports = {"container":"lL-z","recos":"mL-z","productCardOverride":"nL-z"};